import { Directive, Input, TemplateRef, ViewContainerRef, Injector } from '@angular/core';


@Directive({
    selector: '[accountType]'
})
export class AccountTypeDirective {
    private types: any[];
    constructor(
        private injector: Injector,
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef) {
        
    }

    @Input()
    set accountType(value: string | string[]) {
        if (typeof value === 'string') {
            this.types = [value];
        } else {
            this.types = value;
        }
        this.updateView();
    }

    private updateView(): void {
        let accountType = localStorage.getItem('accountType');
        let result = this.types.some(type => type === accountType)  ? true : false;
        this.viewContainerRef.clear();
        if (result) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }
}
